module.exports = __webpack_public_path__ + "static/img/visa-mastercard-powercash.f2f7b30.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/funding/visa-mastercard-powercash.svg
// module id = 569
// module chunks = 0